import plushieImage from '../assets/libby-plushie-shop.jpg';

export const PLUSHIE_PRODUCT = {
  slug: 'libby-plushie',
  id: 'libby-plushie',
  name: 'Libby the Lion Plushie',
  tagline: 'Your favorite lion cub is ready to roar her way into your heart!',
  description:
    'Soft, huggable, and full of heart — the official Libby the Lion plush with her signature rainbow bow, heart details, and that roar-ready smile kids love.',
  image: plushieImage,
  imageAlt: 'Libby the Lion plush toy in a pink gift box with sparkles, roses, and a Libby the Lion tag',
  buyLabel: 'Buy now',
};
